module.exports = __webpack_public_path__ + "img/working-process2.80684d19.png";